

module.exports = __webpack_require__.stylable.create(
    "Tooltip436743931",
    {"classes":{"root":"Tooltip436743931__root"},"vars":{},"stVars":{},"keyframes":{}},
    ".Tooltip436743931__root .Popover2693513086__popoverContent{overflow-wrap:break-word;word-wrap:break-word;word-break:break-word}",
    2,
    "Tooltip436743931",
    __webpack_require__.stylable.$
);
